import { ThunkDispatch } from 'redux-thunk';
import { setEnabledFeaturesAction } from './actions';
import { AppActions, AppState } from 'store';
import { EnabledFeature } from './types';
import { AxiosResponse } from 'axios';
import { webConfig } from 'webConfig';
import { getAxiosClient } from '@givelify/utils';

const url = new URL('api', webConfig.apiUrl);

export const getEnabledFeatures =
    (fingerprint: string): ThunkDispatch<AppState, undefined, AppActions> =>
    (dispatch: any) => {
        const axiosClient = getAxiosClient({ baseURL: webConfig.apiUrl });
        axiosClient(`${url}/enabled-features`, {
            method: 'GET',
            params: { user_key: fingerprint },
        })
            .then((result: AxiosResponse<EnabledFeature[]>) => {
                dispatch(setEnabledFeaturesAction(result.data));
            })
            .catch(() => dispatch(setEnabledFeaturesAction([])));
    };
